import { GenerationParameters, ProductionDrawing } from './production-drawing.dto';

export enum Type {
  STD = 'STD',
  FLEX = 'FLEX',
}

export interface BraceMeasurements {
  C1?: number;
  C2?: number;
  D1?: number;
  D2?: number;
  E1?: number;
  E2?: number;
  F1?: number;
  F2?: number;
}

export interface BraceGenerationParameters extends GenerationParameters {
  supplier?: string;
  tubes?: string;
  braceType?: Type;
}

export interface BraceProductionDrawing extends ProductionDrawing {
  params?: BraceParams;
}

export interface BraceParams {
  drawingParameters?: BraceGenerationParameters;
}
